<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      Demo vue-web-speech
    </v-app-bar>

    <v-main>
      <v-container class="mt-4">
        <h2 class="text-h4 mb-5">Example 1 with input slot</h2>

        <v-row>
          <v-col align="right">
            <vue-web-speech
              v-model="record"
              @results="onResults"
            >
              <template v-slot:input="{text}">
                <v-text-field :value="text" outlined hide-details />
              </template>
            </vue-web-speech>
          </v-col>
          <v-col align-self="center">
            <v-btn
              fab
              x-large
              @click="record = !record"
              :color="record?'red':'green'"
              dark
            >
              <v-icon x-large>mdi-microphone</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <h2 class="text-h4 mt-10 pt-10 mb-5">Example 2 with alert and confidence limit</h2>

        <v-row>
          <v-col align-self="center" class="mt-8">
            <v-slider
              v-model="confidenceLimit"
              label="Confidence limit"
              thumb-label="always"
            />
          </v-col>
          <v-col align-self="center">
            <vue-web-speech
              v-model="record2"
              @results="onResults2"
              @unrecognized="unrecognized"
              :confidence-limit="confidenceLimit/100"
            />
            <v-btn
              fab
              x-large
              @click="record2 = !record2"
              :color="record2?'red':'green'"
              dark
            >
              <v-icon x-large>mdi-microphone</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  data: () => ({
    record: false,
    record2: false,
    confidenceLimit: 80
  }),
  methods: {
    onResults (data) {
      console.log(data)
    },
    onResults2 (data) {
      alert(data.join('\n'))
    },
    unrecognized () {
      alert('Your speech was not recognized, try again or change confidence limit')
    }
  }
}
</script>
